<template>
    <div>
        <ListPage
            row-key="user_id"
            :query="query"
            :total="total"
            v-loading="loading"
            :data="tableData"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            @search="handleSearch"
            @reset="resetQuery"
            @selection-change="handleSelectionChange"
        >
            <template slot="filters">
                <el-form-item label="" prop="search_keyword">
                    <el-input v-model="query.search_keyword" placeholder="输入用户名进行检索" clearable @keyup.enter.native="handleSearch" />
                </el-form-item>
            </template>
            <template slot="btns">
                <el-button :disabled="!ids.length" style="margin-left: 10px" size="mini" type="primary" @click="handleBatchTransfer">
                    批量转移
                </el-button>
                <el-button :disabled="!ids.length" style="margin-left: 10px" size="mini" type="primary" @click="handleBatchDel"> 批量移除 </el-button>
                <el-button style="margin-left: 10px" size="mini" type="primary" @click="handleAdd"> 添加 </el-button>
            </template>
            <template slot="columns">
                <el-table-column type="selection" width="50" align="center"></el-table-column>
                <el-table-column label="ID" align="center" prop="uuid" />
                <el-table-column label="用户名" align="center" prop="nick_name" />
                <el-table-column label="操作" align="center" width="140">
                    <template slot-scope="{ row }">
                        <el-button size="mini" type="text" @click="handleTransfer(row)"> 转移 </el-button>
                        <el-button size="mini" type="text" @click="handleDel(row)"> 移除 </el-button>
                    </template>
                </el-table-column>
            </template>
        </ListPage>
        <Picker ref="picker" @update="search"></Picker>
        <Transfer ref="transfer" @update="search"></Transfer>
    </div>
</template>

<script>
import { list, del } from "@/api/member/relative";
import listMixin from "@/mixins/list";
import Picker from "./picker.vue";
import Transfer from "./transfer.vue";

export default {
    components: { Picker, Transfer },
    data() {
        return {
			list,
            // 查询参数
            query: {
                search_keyword: "",
            },
        };
    },
    mixins: [listMixin],
    created() {
        this.uuid = this.$route.query.uuid;
        this.search();
    },
    methods: {
        search() {
            if (!this.uuid) return;
            const params = {
                uuid: this.uuid,
                ...this.query,
            };
            this._search(params);
        },
        handleAdd() {
            this.$refs.picker.open(this.uuid);
        },
        handleTransfer(row) {
            this.$refs.transfer.open([row], this.uuid);
        },
        handleDel(row) {
            this.$confirm("确定移除该用户吗？", "提示", { type: "warning" })
                .then(() => {
                    del({ uuid: this.uuid, user_uuids: [row.uuid] }).then(({ code, error }) => {
                        if (code === 200) {
                            this.$message.success("移除成功");
                            this.search();
                        } else {
                            this.$message.error(error.message);
                        }
                    });
                })
                .catch(() => {});
        },
        handleBatchTransfer() {
            this.$refs.transfer.open(this.ids, this.uuid, true);
        },
        handleBatchDel() {
            this.$confirm("确定批量移除该用户吗？", "提示", { type: "warning" })
                .then(() => {
                    del({ uuid: this.uuid, user_uuids: this.ids.map((x) => x.uuid) }).then(({ code, error }) => {
                        if (code === 200) {
                            this.$message.success("移除成功");
                            this.search();
                        } else {
                            this.$message.error(error.message);
                        }
                    });
                })
                .catch(() => {});
        },
    },
};
</script>
